import LoadingIcon from '../LoadingLayer/LoadingIcon';
import styles from './RotatingRingIcon.module.scss';

const RotatingRingIcon = () => <LoadingIcon className={styles.icon} />;
export default RotatingRingIcon;
